module.exports = __webpack_public_path__ + "fonts/OpenSans-Regular.5d5735e5.woff2";